import { GetFilterInput } from '@deltek/specification-client/core/Models/projectItem'
import React from 'react'

export interface ProjectTeamFilterContextInterface {
    userFilterValues: Partial<GetFilterInput>[]
    setUserFilterValues: (value: Partial<GetFilterInput>[]) => void
}

export const ProjectTeamFilterContext = React.createContext(
    {} as ProjectTeamFilterContextInterface
)
